<template>
  <div
    id="instruction-comment-panel"
    class="fixed flex justify-end w-screen transition-all duration-500 top-18"
    :style="{
      right: open ? '0vw' : '-100vw',
      height: 'calc(100vh - 4.5rem - 3.5rem)',
      zIndex: 52
    }"
  >
    <div
      class="absolute top-0 left-0 w-screen h-full -z-10"
      @click="$emit('close-panel')"
    ></div>
    <div class="relative z-0 flex flex-col flex-shrink-0 h-full w-120">
      <div>
        <div class="flex items-center justify-between px-6 h-18 bg-pure-white">
          <div class="flex items-center gap-2">
            <div class="cursor-pointer" @click="$emit('close-panel')">
              <BlIcon
                v-if="open"
                icon="arrow-left"
                color="slate-6"
                class="w-6 h-6"
              />
            </div>
            <BlTextTitle4 text="Comment" />
          </div>
          <div class="cursor-pointer" @click="$emit('close-panel')">
            <BlIcon v-if="open" icon="close" color="slate-6" class="w-6 h-6" />
          </div>
        </div>
        <div class="px-3 bg-pure-white">
          <div
            class="flex flex-col gap-1 p-3 border rounded bg-slate-200 border-slate-300"
          >
            <div
              class="flex items-center justify-between truncate cursor-pointer"
              :title="instruction.title"
              @click="chevronOpened = !chevronOpened"
            >
              <BlTextSubtitle3 :text="instruction.title" class="truncate" />
              <BlIcon
                v-if="open"
                icon="chevron-down"
                class="w-4 h-4 transition-all duration-300"
                :style="{ rotate: chevronOpened ? '180deg' : '' }"
              />
            </div>
            <div class="flex">
              <div
                v-html="instruction.description"
                class="text-sm whitespace-pre-line text-slate-700"
                :class="{ 'line-clamp-1': !chevronOpened }"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative flex flex-col justify-between h-full overflow-y-auto bg-pure-white"
      >
        <div class="flex flex-col gap-1 px-3 py-5">
          <div
            v-if="!instruction.comments.length"
            class="grid items-center justify-center h-64 text-center"
          >
            <BlTextBody2
              text="No comments yet. Be the first to share your thoughts on this instruction."
            />
          </div>
          <InstructionCommentItem
            v-for="comment in instruction.comments"
            :key="comment.id"
            :comment="comment"
            @toggle-edit-state="editState = $event"
          />
        </div>
      </div>
      <div
        class="sticky bottom-0 z-0 flex-shrink-0 px-4 py-4 transition-all duration-300 bg-pure-white"
        :class="[
          editState ? 'h-16 opacity-25 overflow-hidden' : 'h-48 opacity-100'
        ]"
      >
        <div v-if="open" class="relative pb-px">
          <BlInputButton
            class="absolute top-2 right-2"
            icon="paper-plane"
            dense
            :disabled="isDisabledSubmit"
            :loading="submitLoading"
            @clicked="onCreate"
          />
          <VueEditor
            :editor-toolbar="customToolbar"
            v-model="bodyInput"
            class="blum-editor"
            placeholder="Comment this instruction"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { VueEditor } from "vue2-editor";

import InstructionCommentItem from "./instructionComment/Item.vue";

import BlIcon from "../../../BlIcon.vue";
import BlTextTitle4 from "../../../BlTextTitle4.vue";
import BlTextSubtitle3 from "../../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../../BlTextBody2.vue";
import BlInputButton from "../../../BlInputButton.vue";

export default {
  name: "CommentPanel",
  components: {
    VueEditor,
    InstructionCommentItem,
    BlIcon,
    BlTextTitle4,
    BlTextSubtitle3,
    BlTextBody2,
    BlInputButton
  },
  props: {
    open: { type: Boolean, default: false },
    instruction: { type: Object, required: true }
  },
  data() {
    return {
      submitLoading: false,
      chevronOpened: false,
      bodyInput: "",
      customToolbar: [["bold", "italic", "underline", "link"]],
      editState: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "prospectStage"]),
    isDisabledSubmit() {
      if (!this.bodyInput) return true;
      if (this.editState) return true;
      return false;
    }
  },
  watch: {
    open() {
      this.bodyInput = "";
    }
  },
  methods: {
    ...mapActions(["createInstructionComment"]),
    onCreate() {
      const data = {
        prospect_stage_id: this.prospectStage.id,
        comment: {
          commentable_id: this.instruction.id,
          commentable_type: "Instruction",
          user_id: this.currentUser.id,
          body: this.bodyInput
        }
      };
      this.submitLoading = true;
      this.createInstructionComment(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.bodyInput = "";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/modal/prospectPanel/CommentPanel.vue